import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { clearStoredSession, redirectToLogin, getStoredUser } from "../utils/sessionUser";
import "./GovernmentPortal.css";
import logo from "../assets/logo.png";

const GovernmentMainLayout = () => {
  const user = getStoredUser();
  const logout = () => {
    clearStoredSession();
    redirectToLogin();
  };

  return (
    <div className="gov-shell">
      <aside className="gov-sidebar">
        <div className="gov-brand">
          <img className="gov-brand-logo" src={logo} alt="Lotus Rice Mill" />
          <div>
            <strong>Government Portal</strong>
            <small>Lotus Rice Mill</small>
          </div>
        </div>
        <NavLink className={({ isActive }) => `gov-nav${isActive ? " active" : ""}`} to="/government/dashboard">
          <span className="material-symbols-outlined">fact_check</span>
          Dashboard
        </NavLink>
        <NavLink className={({ isActive }) => `gov-nav${isActive ? " active" : ""}`} to="/government/thumb-history">
          <span className="material-symbols-outlined">fingerprint</span>
          Thumb Ledger & History
        </NavLink>
        <NavLink className={({ isActive }) => `gov-nav${isActive ? " active" : ""}`} to="/government/profile">
          <span className="material-symbols-outlined">account_circle</span>
          My Profile
        </NavLink>
      </aside>
      <main className="gov-main">
        <header className="gov-topbar">
          <div>
            <strong>{user?.fullName || "Government User"}</strong>
            <span>{user?.governmentProfile?.area || "Area office"}</span>
          </div>
          <button className="gov-logout" onClick={logout}>Logout</button>
        </header>
        <Outlet />
      </main>
    </div>
  );
};

export default GovernmentMainLayout;
